












































































































































































































































































































































// @ts-nocheck
import { Component, Vue, Prop } from "vue-property-decorator";
import { jsPDF } from "jspdf";

@Component
export default class LabResult extends Vue {
  @Prop(String) readonly publicId!: string;
  @Prop() readonly visit!: any;
  abbreviations = Array<any>();
  setAbbreviations() {
    let names = this.visit.detail.map((item) => item.Abbreviation);
    names = [...new Set(names)];
    this.abbreviations = names.map((name) => {
      return {
        name,
        list: this.getDetAbbreviations(name),
      };
    });
  }
  getDetAbbreviations(abbrev: string): Array<any> {
    return this.visit.detail.filter((item) => item.Abbreviation === abbrev);
  }
  getTexts(id) {
    return this.visit.texts.filter(
      (item) => item.ResultGroupCannedTextID === id
    );
  }
  async pdf() {
    const el = document.getElementById("result");
    const doc = new jsPDF({
      orientation: "portrait",
      unit: "px",
      format: [el.offsetWidth, el.offsetHeight + 50],
      hotfixes: ["px_scaling"],
    });
    doc.html(el, {
      callback: (doc) => {
        doc.save(`RESULTS_${this.publicId}.pdf`);
      },
      x: 0,
      y: 0,
    });
  }
  async getEntityLogo() {
    if (!this.visit.header.EntityLogoID) return;
    const params = new FormData();
    params.append("id", this.visit.header.EntityLogoID);
    const { data } = await Vue.axios.post("labs/content", params, {
      responseType: "blob",
    });
    const blob = new Blob([data], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    document.getElementById("entity-logo").src = url;
  }
  async mounted() {
    if (!this.visit) {
      this.$router.push({
        name: "LabLogin",
        replace: true,
      });
    }
    this.getEntityLogo();
    this.setAbbreviations();
  }
}
